import React from 'react'
import { Box } from '@material-ui/core'
import { useStyles } from './styles'
import { useSelector } from 'react-redux'
import Loader from 'web/src/app/root/components/common/loader'

export const CommentCardHeader = ({
    comment,
    date,
    time,
    locale,
    isCommentInEditMode,
    commentId
}) => {
    const classes = useStyles()
    const { imagesLoader } = useSelector(state => state.reports)

    if (isCommentInEditMode) return null

    return (
        <Box className={classes.commentSection}>
            <Box
                component="span"
                style={{
                    fontWeight: 'bold'
                }}>
                {comment.name}
            </Box>
            <Box component="span" className={classes.dateTimeComment}>
                {imagesLoader === commentId ? (
                    <Loader />
                ) : (
                    <>
                        {date}
                        {locale.reports.at}
                        {time}
                    </>
                )}
            </Box>
        </Box>
    )
}
